export const handleWipClick = async (task, setTaskState) => {
  try {
    const newState =
      task.taskState === "task_state_wip"
        ? "task_state_backlog"
        : "task_state_wip";
    await setTaskState(task.id, newState);
    console.log(`Task ${task.id} state updated to ${newState}`);
  } catch (error) {
    console.error("Error updating task state:", error);
  }
};
